import { Empty } from "antd";
import ChequeBookRequestCard from "../chequeBookRequest";
import { useTranslation } from "react-i18next";


export default function ChequeBookListItem({ dataSource = [] }) {
  const { t } = useTranslation();
  return (
    <>
      {dataSource.length === 0 ? (
        <Empty description={t("common.no_records_found", {
              defaultValue: "No Records Found",
            })} />
      ) : (
        <div>
          {dataSource.map((option, index) => (
            <ChequeBookRequestCard record={option} />
          ))}
        </div>
      )}
    </>
  );
}
